<template>
  <!-- 0 件状態の fallback（Empty 下）では、見出し左に icon prefix を付与する。
       onViewMore が指定された場合はフィルターモーダルへの導線として View More ボタンを表示する -->
  <div class="flex items-center justify-between">
    <h2 class="flex items-center gap-1 font-Spectral text-[20px] capitalize leading-7 tracking-[0.5px] text-gray9">
      <img v-if="iconSrc" alt="" class="size-6 shrink-0" :src="iconSrc" />
      <span>{{ title }}</span>
    </h2>
    <button
      v-if="onViewMore"
      class="flex items-center gap-0.5 font-Spectral text-[14px] leading-5 text-gold3 hover:opacity-80"
      type="button"
      :data-testid="`view-more-${title.toLowerCase().replace(/\s+/g, '-')}`"
      @click="onViewMore"
    >
      {{ viewMoreLabel ?? 'View More' }}
      <img alt="" class="size-5" :src="arrowRightGoldIcon" />
    </button>
  </div>
</template>

<script setup lang="ts">
import arrowRightGoldIcon from '@/assets/icon/arrow/right-gold.svg';

defineProps<{
  title: string;
  iconSrc?: string;
  onViewMore?: () => void;
  // View More ボタンの文言。未指定時は 'View More'（Dates セクションでは 'Select Dates' を渡す）
  viewMoreLabel?: string;
}>();
</script>
